import React from 'react';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';

export const StyledTabs = styled(props => {
  return <Tabs {...props} classes={{ indicator: 'indicator' }}></Tabs>;
})`
  && {
    background-color: #fff;
    border-radius: 60px 60px;
    margin-bottom: 24px;
    opacity: 1;
    min-height: 30px;
    .MuiTab-wrapper {
      justify-content: center;
      flex-direction: row;
    }
  }
  && .indicator {
    height: 0px;
  }
`;
export const StyledTab = styled(Tab)`
  && {
    color: #373839;
    height: 2px;
    background-color: #e7e9ed;
    border-radius: 60px 60px;
    margin-right: 4px;
    margin-left: 4px;
    min-height: 32px;
    width: fit-content;
    max-width: unset;
    padding: 10px !important;
    font-size: 14px !important;
    line-height: 5px;
    letter-spacing: 0;
    text-transform: none;
    border-right: 1px solid #fff;
    border-left: 1px solid #fff;
    &:focus {
      color: #ffffff !important;
      background-color: #162952 !important;
      border-radius: 60px 60px;
    }
    &.MuiTab-textColorInherit {
      opacity: 1;
    }
    &&.Mui-selected {
      color: #ffffff;
      background-color: #162952;
      border-radius: 60px 60px;
    }
  }
`;
export const Container = styled.main`
  background-color: #fff;
  padding: 16px;
  margin-bottom: 20px;
`;
